(function(window, document){
  'use strict';
  var PS = window.PS || (window.PS = {});
  var Search = PS.Search || (PS.Search = {});
  var inflight = {};
  var fields = ['make', 'year', 'model', 'color', 'code', 'make_slug', 'color_slug'];

  function text(value, max){
    var valueText = value == null ? '' : String(value).replace(/^\s+|\s+$/g, '');
    return valueText && valueText.length <= max && !/[\x00-\x1f\x7f]/.test(valueText) ? valueText : '';
  }
  function safeSlug(value){
    var valueText = text(value, 100).toLowerCase();
    var classify = Search.classifySensitive;
    return /^[a-z0-9][a-z0-9-]*$/.test(valueText) && typeof classify === 'function' && !classify(valueText) ? valueText : '';
  }
  function safeName(value){
    var valueText = text(value, 60);
    var classify = Search.classifySensitive;
    return /^[a-z0-9 .()'\-\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u00ff]+$/i.test(valueText) && typeof classify === 'function' && !classify(valueText) ? valueText : '';
  }
  function safeContext(input, status){
    var out = {};
    var i, key, valueText;
    if (!input || typeof input !== 'object') return out;
    for (i = 0; i < fields.length; i++) {
      key = fields[i];
      valueText = key === 'make_slug' || key === 'color_slug' ? safeSlug(input[key]) :
        (key === 'make' || key === 'model' || key === 'color' || key === 'code' ? safeName(input[key]) : text(input[key], 4));
      if (key === 'year' && valueText && !/^\d{4}$/.test(valueText)) valueText = '';
      if (input[key] != null && String(input[key]) !== '' && !valueText) {
        if (status) status.invalid = true;
        return {};
      }
      if (valueText) out[key] = valueText;
    }
    return out;
  }
  function allScope(){ return /(?:^|[?&])scope=all(?:&|$)/i.test(String(window.location && window.location.search || '')); }
  function urlQueryMatches(query){
    var search = String(window.location && window.location.search || '').replace(/^\?/, '').split('&');
    var i, part, key, valueText;
    for (i = 0; i < search.length; i++) {
      part = search[i].split('=');
      key = part.shift();
      if (key !== 'q') continue;
      valueText = part.join('=').replace(/\+/g, ' ');
      try { valueText = decodeURIComponent(valueText); } catch (_e) { return false; }
      return String(query || '').replace(/^\s+|\s+$/g, '') === valueText.replace(/^\s+|\s+$/g, '');
    }
    return false;
  }
  function formatChoice(query){
    var words = String(query || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/^\s+|\s+$/g, '').split(/\s+/);
    var textValue = words.join(' ');
    var prefix = '(?:paint |touch up(?: paint)? )?';
    if (new RegExp('^' + prefix + 'spray(?: cans?| paint)?$').test(textValue) || textValue === 'spray can paint') return { types: ['spray'] };
    if (new RegExp('^' + prefix + 'pen or bottle$').test(textValue) || new RegExp('^' + prefix + 'pens or bottles$').test(textValue)) return { types: ['pen', 'bottle'] };
    if (new RegExp('^' + prefix + 'pen$').test(textValue) || new RegExp('^' + prefix + 'pens$').test(textValue)) return { types: ['pen'] };
    if (new RegExp('^' + prefix + 'bottles?$').test(textValue) || textValue === 'bottle with brush') return { types: ['bottle'] };
    if (new RegExp('^' + prefix + 'kits?$').test(textValue)) return { kind: 'kit', types: [] };
    if (/^(?:compare|comparison|compare products|product comparison)$/.test(textValue)) return { kind: 'compare', types: [] };
    return null;
  }
  function isMultiword(query){ return String(query || '').replace(/^\s+|\s+$/g, '').split(/\s+/).length > 1; }
  function routeSlugs(){
    var match = String(window.location && window.location.pathname || '').match(/^\/colors\/([a-z0-9-]+)\/([a-z0-9-]+)(?:\/(?:pen|bottle|spray|pro|kit-pen|kit-bottle|kit-spray))?\/?$/i);
    return match ? { make_slug: match[1].toLowerCase(), color_slug: match[2].toLowerCase() } : null;
  }
  function sameVehicle(a, b){
    return String(a.make || '').toLowerCase() === String(b.make || '').toLowerCase() &&
      String(a.year || '') === String(b.year || '') && String(a.model || '').toLowerCase() === String(b.model || '').toLowerCase();
  }
  function matchesQuery(query, context){
    var valueText = String(query || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/^\s+|\s+$/g, ' ');
    var candidates = [context.make, context.model, context.color, context.code, context.color_slug];
    var i, candidate;
    if (!valueText || formatChoice(query)) return true;
    for (i = 0; i < candidates.length; i++) {
      candidate = String(candidates[i] || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/^\s+|\s+$/g, ' ');
      if (candidate && candidate.indexOf(valueText) !== -1) return true;
    }
    return false;
  }
  Search.contextForQuery = function(query, explicitScope){
    var old = {};
    var ssr = null;
    var route = routeSlugs();
    var result = {};
    var classify = Search.classifySensitive;
    var status = {};
    var explicit = safeContext(explicitScope, status);
    var explicitPresent = !!(explicit.make || explicit.year || explicit.model);
    if (allScope() || status.invalid || (typeof classify === 'function' && classify(query))) return result;
    if (explicitPresent && !urlQueryMatches(query) && !matchesQuery(query, explicit)) return result;
    // Keep a multiword scoped result only while its query still matches the URL q.
    if (isMultiword(query) && !formatChoice(query) && !(explicitPresent && urlQueryMatches(query))) return result;
    try {
      var saved = PS.cc && PS.cc.read ? PS.cc.read() : null;
      if (saved && PS.cc.isStale && !PS.cc.isStale(saved)) old = safeContext(saved);
    } catch (_e) { old = {}; }
    result = explicit;
    if (result.make || result.year || result.model) {
      if (sameVehicle(result, old) && matchesQuery(query, old)) {
        if (!result.color && old.color) result.color = old.color;
        if (!result.code && old.code) result.code = old.code;
        if (!result.color_slug && old.color_slug) result.color_slug = old.color_slug;
        if (!result.make_slug && old.make_slug) result.make_slug = old.make_slug;
      } else {
        delete result.color; delete result.code; delete result.color_slug;
      }
      return result;
    }
    try { ssr = PS.ssr ? PS.ssr() : null; } catch (_e2) { ssr = null; }
    if (route && ssr && ssr.valid && safeSlug(ssr.make_slug) === route.make_slug && safeSlug(ssr.color_slug) === route.color_slug) {
      result = safeContext(ssr);
      if (!result.make_slug) result.make_slug = route.make_slug;
      if (!result.color_slug) result.color_slug = route.color_slug;
      return matchesQuery(query, result) ? result : {};
    }
    if (!matchesQuery(query, old)) return {};
    result = old;
    if (!(result.color && result.code && result.make_slug && result.color_slug)) {
      delete result.color; delete result.code; delete result.color_slug;
    }
    return result;
  };
  function canonicalProductUrl(url, makeSlug, colorSlug){
    var textValue = String(url || '');
    var match;
    if (/^https:\/\//i.test(textValue)) {
      match = textValue.match(/^https:\/\/([^\/:?#]+)(\/[^?#]*)$/i);
      if (!match || !/^(?:www\.paintscratch\.com|dev\.paintscratch\.com|compat-dev\.paintscratch\.com)$/i.test(match[1])) return '';
      textValue = match[2];
    } else if (/^[a-z]+:\/\//i.test(textValue)) return '';
    if (!/^\/colors\/[a-z0-9-]+\/[a-z0-9-]+\/(pen|bottle|spray|pro)\/?$/i.test(textValue)) return '';
    match = textValue.match(/^\/colors\/([^/]+)\/([^/]+)\//i);
    return match && match[1].toLowerCase() === makeSlug && match[2].toLowerCase() === colorSlug ? textValue : '';
  }
  function productUrls(data, makeSlug, colorSlug){
    var source = data && data.products;
    var urls = {};
    var i, key, url, match;
    function add(entryValue){
      if (!entryValue || typeof entryValue !== 'object') return;
      url = canonicalProductUrl(entryValue.url, makeSlug, colorSlug);
      match = url && url.match(/\/(pen|bottle|spray|pro)\/?$/i);
      if (match) urls[match[1].toLowerCase()] = url;
    }
    if (Array.isArray(source)) {
      for (i = 0; i < source.length; i++) add(source[i]);
    } else if (source && typeof source === 'object') {
      for (key in source) if (Object.prototype.hasOwnProperty.call(source, key)) add(source[key]);
    }
    return urls;
  }
  function actionsFor(data, query, makeSlug, colorSlug){
    var choice = formatChoice(query);
    var products = ['pen', 'bottle', 'spray', 'pro'];
    var labels = { pen: 'Paint pen', bottle: 'Paint bottle', spray: 'Spray can', pro: 'Professional size' };
    var urls, actions = [], i, type, url;
    if (!data || data.valid !== true || safeSlug(data.make_slug) !== makeSlug || safeSlug(data.color_slug) !== colorSlug) return actions;
    if (!choice) choice = { types: products };
    if (choice.kind) {
      actions.push({ id: 'color_hub', kind: 'link', label: 'View this color', url: '/colors/' + makeSlug + '/' + colorSlug + '/' });
      actions.push({ id: 'what_to_order', kind: 'link', label: 'Compare paint products', url: '/pages/what-to-order' });
      return actions;
    }
    urls = productUrls(data, makeSlug, colorSlug);
    for (i = 0; i < choice.types.length; i++) {
      type = choice.types[i];
      url = urls[type] || '';
      if (url) actions.push({ id: 'paint_' + type, kind: 'link', label: labels[type], url: url });
    }
    return actions;
  }
  Search.loadFormatActions = function(query, context){
    var scope = safeContext(context);
    var ms = scope.make_slug;
    var cs = scope.color_slug;
    var key = ms && cs ? ms + '/' + cs : '';
    var entry;
    var fetcher = window.fetch;
    var classify = Search.classifySensitive;
    if (!key || !(scope.color || scope.code) || (typeof classify === 'function' && classify(query)) ||
      !matchesQuery(query, scope) || !fetcher || !PS.u || !PS.u.apiBase) return window.Promise.resolve([]);
    entry = inflight[key];
    if (!entry) {
      entry = { promise: null };
      inflight[key] = entry;
      entry.promise = new window.Promise(function(resolve){
        var settled = false;
        var timer = window.setTimeout(function(){
          if (settled) return;
          settled = true;
          if (inflight[key] === entry) delete inflight[key];
          resolve(null);
        }, 4500);
        function finish(data){
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          if (inflight[key] === entry) delete inflight[key];
          resolve(data);
        }
        window.Promise.resolve().then(function(){
          return fetcher.call(window, PS.u.apiBase() + 'shopify/cars/' + encodeURIComponent(ms) + '/' + encodeURIComponent(cs), { credentials: 'omit' });
        }).then(function(response){
          if (!response || !response.ok) return null;
          return response.json();
        }).then(function(data){
          if (data && data.valid === true && safeSlug(data.make_slug) === ms && safeSlug(data.color_slug) === cs && inflight[key] === entry) finish(data);
          else finish(null);
        }, function(){ finish(null); });
      });
    }
    return entry.promise.then(function(data){
      try { return actionsFor(data, query, ms, cs); } catch (_e) { return []; }
    }, function(){ return []; });
  };
  Search.clearContext = function(){
    if (PS.cc && PS.cc.write) PS.cc.write({ make: '', model: '', color: '', code: '', hex: '', year: '', factory_code: '', make_slug: '', color_slug: '', vehicle_scope: false, ps_from_search: false });
    try { document.dispatchEvent(new window.CustomEvent('ps:color:cleared', {detail:{clearVehicle:true}})); } catch (_e) {}
  };
})(window, document);
